import type { RouteObject } from 'react-router'

import { lazy } from '../../../routes/lazy'
import { DealerOnlyGuard } from '../components/DealerOnlyGuard'

export const dealerRoutes: RouteObject[] = [
  {
    Component: DealerOnlyGuard,
    children: [
      {
        index: true,
        Component: lazy(() => import('@features/dealer/routes/DealerOperations'))
      },
      {
        path: 'create-customer-operation',
        Component: lazy(() => import('@features/dealer/routes/CreateCustomerOperation'))
      },
      {
        path: 'handoff/:farmerOrgCode',
        Component: lazy(() => import('@features/dealer/routes/DealerHandoff'))
      }
    ]
  }
]
